export const hasSkills = categories =>
  categories.length && categories[0].skills && Array.isArray(categories[0].skills);

export const maxCategoryOptions = 3;
export const maxSkillsOptions = 2;
